//confirmation dialog on accept all/ reject all
// button click to make sure user knows what button they clicked

import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { LoadingButtonText } from "../../common";

export function BulkApprovalConfirmationDialog(props) {
  const handleClose = () => {
    props.setOpen(false);
  };

  return (
    <Dialog
      open={props.open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      {/* dynamic dialog title */}
      <DialogTitle id="alert-dialog-title">
        Bulk {props.approval === "Accepted" ? "Approval" : "Rejection"}
      </DialogTitle>
      <DialogContent>
        {/* dynamic dialog description */}
        <DialogContentText id="alert-dialog-description">
          Are you sure you want to{" "}
          {props.approval === "Accepted" ? "Approve" : "Reject"} all of the
          selected items?
          <br />
          This action can not be reversed.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          size="small"
          variant="contained"
          sx={{
            padding: "10px 20px",
            m: "0 0 20px 0",
            fontSize: "14px",
            backgroundColor: "#c7ab79",
            "&:hover": {
              backgroundColor: "#c4943f",
            },
          }}
          onClick={() => props.handleSubmit(props.approval)}
          autoFocus
        >
          <LoadingButtonText
            loading={props.isSubmitting}
            text={props.approval === "Accepted" ? "Approve All" : "Reject All"}
          />
        </Button>
        <Button
          size="small"
          sx={{
            padding: "10px 20px",
            m: "0 20px 20px 0",
            fontSize: "14px",
          }}
          onClick={handleClose}
        >
          <LoadingButtonText loading={props.isSubmitting} text="Cancel" />
        </Button>
      </DialogActions>
    </Dialog>
  );
}
